export default class Order {
	name = null;
	externalOrderId = null;
	timestamp = null;
	total = null;
	distributionType = null;
	distributionTypeDesc = null;
	waitstaffTarget = null;
	orderItems = [];
}